import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import OrderWaiting from "@/pages/OrderWaiting";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import WorkerDashboard from "@/pages/WorkerDashboard";
import CustomerPortal from "@/pages/CustomerPortal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Terms from "@/pages/Terms";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import NotificationPrompt from "@/components/NotificationPrompt";
import MobileBottomNav from "@/components/MobileBottomNav";
import { getAuthUser } from "@/lib/api";

function RequireRole({ role, children }) {
  const user = getAuthUser();
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/worker" replace />;
  if (role === "staff" && !["admin", "worker"].includes(user.role))
    return <Navigate to="/login" replace />;
  if (role === "customer" && user.role !== "customer")
    return <Navigate to="/login" replace />;
  return (
    <>
      {children}
      <NotificationPrompt />
    </>
  );
}

function App() {
  return (
    <div className="App noise">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/order/:id" element={<OrderWaiting />} />
          <Route path="/success/:id" element={<OrderSuccess />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/login" element={<Login />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terminos" element={<Terms />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={
              <RequireRole role="admin">
                <AdminDashboard />
              </RequireRole>
            }
          />
          <Route
            path="/worker"
            element={
              <RequireRole role="staff">
                <WorkerDashboard />
              </RequireRole>
            }
          />
          <Route
            path="/mi-cuenta"
            element={
              <RequireRole role="customer">
                <CustomerPortal />
              </RequireRole>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <MobileBottomNav />
      </BrowserRouter>
      <PWAInstallPrompt />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#18181b",
            color: "#fafafa",
            border: "1px solid rgba(255,255,255,0.08)",
          },
        }}
      />
    </div>
  );
}

export default App;
